<template>
    <b-tbody class="address-content">
        <b-tr v-if="is_visible('representative')">
            <b-th class="shipping-address-th" :class="{ required: fields.representative }">担当者(en)</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'representative']"
                    size="sm"
                    :data="prefix + 'representative'"
                    ></b-form-input>
                <small class="example">例）Taro Yamada</small>
                <input-error :errors="error[prefix + 'representative']" />
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('company')">
            <b-th class="shipping-address-th" :class="{ required: fields.company }">会社名(en)</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'company']"
                    size="sm"
                    :data="prefix + 'company'"
                    ></b-form-input>
                <small class="example">例）Yamada Co., Ltd.</small>
                <input-error :errors="error[prefix + 'company']" />
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('line1')">
            <b-th class="shipping-address-th" :class="{ required: fields.line1 }">住所1行目(en)</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'line1']"
                    size="sm"
                    :data="prefix + 'line1'"
                    ></b-form-input>
                <small class="example">例）1-2-3, Oshiage</small>
                <input-error :errors="error[prefix + 'line1']" />
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('line2')">
            <b-th class="shipping-address-th" :class="{ required: fields.line2 }">住所2行目(en)</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'line2']"
                    size="sm"
                    :data="prefix + 'line2'"
                    ></b-form-input>
                <input-error :errors="error[prefix + 'line2']" />
                <small class="example">例）Tokyo Skytree</small>
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('city')">
            <b-th class="shipping-address-th" :class="{ required: fields.city }">都市名(en)</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'city']"
                    size="sm"
                    :data="prefix + 'city'"
                    ></b-form-input>
                <small class="example">例）Sumida</small>
                <input-error :errors="error[prefix + 'city']" />
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('state')">
            <b-th class="shipping-address-th" :class="{ required: fields.state }">都道府県/州(en)</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'state']"
                    size="sm"
                    :data="prefix + 'state'"
                    ></b-form-input>
                <small class="example">例）Tokyo</small>
                <input-error :errors="error[prefix + 'state']" />
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('zip')">
            <b-th class="shipping-address-th" :class="{ required: fields.zip }">郵便番号</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'zip']"
                    size="sm"
                    :data="prefix + 'zip'"
                    ></b-form-input>
                <small class="example">例）1310045</small>
                <input-error :errors="error[prefix + 'zip']" />
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('country')">
            <b-th class="shipping-address-th" :class="{ required: fields.country }">国名(en)</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <SelectCountry
                    v-model="value[prefix + 'country']"
                    />
                <input-error :errors="error[prefix + 'country']" />
                <small class="example">例）Japan</small>
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('tel')">
            <b-th class="shipping-address-th" :class="{ required: fields.tel }">TEL</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'tel']"
                    size="sm"
                    :data="prefix + 'tel'"
                    ></b-form-input>
                <small class="example">例）+8180××××××××</small>
                <input-error :errors="error[prefix + 'tel']" />
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('email')">
            <b-th class="shipping-address-th" :class="{ required: fields.email }">メールアドレス</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'email']"
                    size="sm"
                    :data="prefix + 'email'"
                    ></b-form-input>
                <small class="example">例）taro@example.com</small>
                <input-error :errors="error[prefix + 'email']" />
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('vat_id')">
            <b-th class="shipping-address-th" :class="{ required: fields.vat_id }">VAT ID</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'vat_id']"
                    size="sm"
                    :data="prefix + 'vat_id'"
                    ></b-form-input>
                <input-error :errors="error[prefix + 'vat_id']" />
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('eori')">
            <b-th class="shipping-address-th" :class="{ required: fields.eori }">EORI</b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <b-form-input
                    v-model="value[prefix + 'eori']"
                    size="sm"
                    :data="prefix + 'eori'"
                    ></b-form-input>
                <input-error :errors="error[prefix + 'eori']" />
            </b-td>
        </b-tr>
        <b-tr v-if="is_visible('tax_id')">
            <b-th class="shipping-address-th" :class="{ required: fields.tax_id }">
                TAX ID
                <small class="text-danger">未実装（実装予定）</small>
            </b-th>
            <b-td v-for="prefix in prefixes" :key="prefix">
                <div class="border rounded p-1 min-height-4-5 bg-white" v-b-modal="'modal-tax_id-' + prefix">
                    <div v-for="v in $store.state.app.data.tax_id_types" v-if="value[prefix + 'tax_id'][v]">
                        <strong>{{ v }}</strong>
                        {{ value[prefix + 'tax_id'][v] }}
                    </div>
                </div>
                <b-modal :id="'modal-tax_id-' + prefix" ok-only>
                    <div v-for="v in $store.state.app.data.tax_id_types">
                        {{ v }}
                        <b-form-input
                            v-model="value[prefix + 'tax_id'][v]"
                            size="sm"
                            ></b-form-input>
                    </div>
                </b-modal>
                <input-error :errors="error[prefix + 'tax_id']" />
            </b-td>
        </b-tr>
    </b-tbody>
</template>

<script>
import { mapGetters } from 'vuex'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ShareButtons from '@/components/ShareButtons.vue'
import InputError from '@/components/InputError.vue'
import blueimpLoadImage from 'blueimp-load-image'
import SelectCountry from '@/components/SelectCountry.vue'

export default {
    components: {
        Item,
        ItemBadges,
        ShareButtons,
        SelectCountry,
        InputError,
    },
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return null
            },
        },
        error: {
            type: Object,
            required: false,
            default() {
                return {}
            },
        },
        prefixes: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        fields: {
            type: Object,
            required: false,
            default() {
                return {
                    representative: true,
                    company: false,
                    line1: true,
                    line2: false,
                    city: true,
                    state: true,
                    zip: true,
                    country: true,
                    tel: true,
                    email: true,
                    tax_id: false,
                    vat_id: false,
                    eori: false,
                }
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'trans',
        ])
    },
    mounted() {},
    methods: {
        dummy ($event) {
        },
        is_visible (field_name) {
            if (typeof this.fields !== 'object') {
                return true
            }
            if (field_name in this.fields) {
                return true
            }
            return false
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.table.b-table.b-table-stacked > tbody > tr {
    & > th {
        display: flex;
        padding-bottom: 0;
    }
    & > td {
        padding-top: 0;

        & > div > .example {
            display: none;
        }
    }
}
</style>

